export function ProError() {
  return (
    <div className="text-red-500 mt-4 px-4">
      The pro servers are currently experiencing issues. We apologize for the
      inconvenience. Please try again in a few seconds.
    </div>
  );
}
